import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { replaysApi } from '@/lib/api/replays.api';
import { ACTIVE_REPLAY_STATUSES } from '@/lib/api/replays.constants';

import type { CreateReplayInput } from '@/lib/api/replays.api';

const QK = ['replays'];

export function useReplayList(sourceCallId?: string) {
  return useQuery({
    queryKey: [...QK, sourceCallId ?? 'all'],
    queryFn: () => replaysApi.list(sourceCallId),
    refetchInterval: (q) =>
      q.state.data?.some((r) => ACTIVE_REPLAY_STATUSES.has(r.status)) ? 4000 : false,
  });
}

export function useReplay(id: string | undefined) {
  return useQuery({
    queryKey: [...QK, 'one', id],
    queryFn: () => replaysApi.get(id!),
    enabled: !!id,
    refetchInterval: (q) =>
      q.state.data && ACTIVE_REPLAY_STATUSES.has(q.state.data.status) ? 3000 : false,
  });
}

export function useCreateReplay() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateReplayInput) => replaysApi.create(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useCancelReplay() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => replaysApi.cancel(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}
